<template>
<!-- MOBILE -->


  <div v-if="vmode === 3" class="pt-2 pb-2 pl-4" style="white-space: initial;">
    <v-row class="align-center flex-nowrap">

      <v-avatar tile size="36" class="mr-2">
        <img class="" src="@/assets/img/illustrations/production.png" alt="cardboard box">
      </v-avatar>

      <v-row>

        <template v-if="item.archive_id">

          <div
          class="underline-link"
          @click.stop="$root.$timelineNav.open(item.archive_id)">
            RID:
            {{ item.archive_id }}
          </div>

          &nbsp;
          -
        </template>
        &nbsp;
        <span class="">{{ item.name }}</span>
        &nbsp;

        <v-spacer></v-spacer>
      

        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.yield ? item.yield : item.quantity"
        :key="item.inventory_item_id + 'b'"
        alwaysScale
        labelMode
        class="textSecondary--text text-uppercase"
        ></c-ms-ii>

        &nbsp;

        <v-icon v-if="item.automatic_mode" small class="mr-2">mdi-robot</v-icon>
        <v-icon v-else small class="mr-2">mdi-face</v-icon> 

      </v-row>
    </v-row>

  </div>

  <!-- PC -->
  <!--
  <div v-else
  v-ripple
  :class="['c-flex-r1 border-b--thin align-center mrow pa-2', {'selected-row': selected[item.tempID]}]">

    <v-btn
    icon
    @click.stop="$emit('checkRow', item)"
    :color="selected[item.tempID] ? 'color1' : ''">
      <v-icon> 
        {{ selected[item.tempID] ? 'mdi-check-box-outline' : 'mdi-checkbox-blank-outline' }}
      </v-icon>
    </v-btn>
    
    <v-avatar
    size="48"
    >
      <img class="pa-1" src="@/assets/img/illustrations/production.png" alt="waste">
    </v-avatar>

    <v-layout align-center class="pl-2 pr-2">
      <v-flex xs6>

        <div
        v-if="item.archive_id"
        class="rlink-hover color1--text"
        style="text-decoration: none;display:inline-flex;align-items: center;"
        @click.stop="$root.$timelineNav.open(item.archive_id)">
          <v-icon small color="color1" style="transition: none;">mdi-qrcode-scan</v-icon>
          <span class="ml-1">{{ item.archive_id }}</span>
        </div>

        <div class="text-ellipsed" v-html="item.definition.name">
        </div>
        <div class="">
          <div>
            <c-ms-ii
            :metric_definition="item.metric_definition" 
            :realValue="item.quantity"
            :key="item.inventory_item_id + 'b'"
            alwaysScale
            labelMode
            :class="[{'text-line-through caption text--text text--darken-1': item.yield}, item.automatic_mode === 1 ? 'green--text' : 'blue--text', 'overline']"
            ></c-ms-ii>

          </div>
          <template v-if="item.yield">
            <c-ms-ii
            :metric_definition="item.metric_definition" 
            :realValue="item.yield"
            :key="item.inventory_item_id + 'c'"
            alwaysScale
            labelMode
            ></c-ms-ii>
          </template>
          
        </div>
      </v-flex>

      <v-flex xs6>
        <v-layout align-center class="caption">
          <v-icon small color="text">mdi-barcode</v-icon>
          <span class="ml-1" v-if="item.batch_number">{{ item.batch_number }}</span>
          <span class="ml-1 grey--text" v-else>batch number not set</span>
        </v-layout>
        <v-layout align-center class="caption">
          <v-icon small class="mr-1" color="text">mdi-update</v-icon>
          <div v-if="expiryDateHuman">
            {{ expiryDateHuman }}
          </div>
          <div :class="{'grey--text': !expiryDate}">
            {{ expiryDate || 'expiry not set'}}
          </div>
    
        </v-layout>
      </v-flex>

      <v-menu 
      v-if="!item.yield" 
      open-on-hover top offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon color="red darken-2">mdi-alert-circle-outline</v-icon>
          </v-btn>
        </template>
        <div class="pa-2">
          Enter a final yield
        </div>
      </v-menu>
    </v-layout>

  </div>
  -->
  <!-- PC -->
  <tr v-else
  :class="{'selected': selected[item.tempID]}">
    <td class="sticky">
      <v-layout align-center>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>

        <v-avatar tile size="66" class="mr-2">
          <img class="" src="@/assets/img/illustrations/production.png" alt="cardboard box">
        </v-avatar>

        <div class="text-ellipsed">

          <div class="text-ellipsed font-weight-medium" v-html="item.definition.name">
          </div>

          <v-icon v-if="item.automatic_mode" small class="mr-2" color="green">mdi-robot</v-icon>
          <v-icon v-else small class="mr-2" color="blue">mdi-face</v-icon> 

          <div>
            <span class="overline textSecondary--text">
              Yield:
            </span>
            <v-chip
            v-if="!item.yield"
            color="pink"
            x-small
            text-color="white">
              NOT SET
            </v-chip>
            <c-ms-ii
            v-else
            :metric_definition="item.definition" 
            :realValue="item.yield"
            :key="item.inventory_item_id + 'c'"
            alwaysScale
            labelMode
            ></c-ms-ii>
          </div>

          <div>
            <span class="overline textSecondary--text">
              Expected:&nbsp;
            </span>
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue="item.quantity"
            :key="item.inventory_item_id + 'c'"
            alwaysScale
            labelMode
            :class="[{'text-line-through caption': item.yield}]"
            ></c-ms-ii>
          </div>

          <v-row class="align-center caption">
            <span class="overline textSecondary--text">
              Barcode:&nbsp;
            </span>
            <span v-if="item.batch_number">{{ item.batch_number }}</span>
            <span class="ml-1 grey--text" v-else>not set</span>
          </v-row>

          <v-row class="align-center caption">
            <span class="overline textSecondary--text">
              Expiry:&nbsp;
            </span>
            <div v-if="expiryDateHuman">
              {{ expiryDateHuman }}
            </div>
            &nbsp;
            <div :class="{'grey--text': !expiryDate}">
              {{ expiryDate || 'not set'}}
            </div>      
          </v-row>

          <div
          v-if="item.archive_id"
          class="underline-link"
          @click.stop="$root.$timelineNav.open(item.archive_id)">
            RID:
            {{ item.archive_id }}
          </div>

        </div>

      </v-layout>
    </td>

  </tr>
</template>

<script>
export default {
  props: ['item', 'vmode', 'selected', 'inventoryView'],
  data () {
    return {
      build: this.$store.state.db.productBuilds.builds[this.item.product_build]
    }
  },
  computed: {
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD/MM/YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
/* .selected-row {
  border: thin solid var(--v-color1-base);
  border-radius: 4px;
  
  &::before {
    background: var(--v-color1-base);
    height: 100%;
    width: 100%;
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    opacity: 0.1;
  }
} */
.selected-row {
  /* background: #f5f8fa; */
}
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
</style>
